import React from "react";
import "./nextArrowButton.scss";

interface NextArrowButtonInterface {
    onClick?: () => void;
    canGoNext: boolean;
}

const NextArrowButton = (props: NextArrowButtonInterface) => {
    const {onClick, canGoNext} = props;

    return (
        <button
            onClick={canGoNext? onClick : undefined}
            className={`a-next-arrow-button ${!canGoNext ? 'disabled' : ''}`}
            type="button"
            aria-label="Siguiente"
        />
    );
}

export default NextArrowButton;
